// extracted by mini-css-extract-plugin
export default {"root":"Aside-module--root--f9f9d","sticky":"Aside-module--sticky--e6930"};